import { render, staticRenderFns } from "./DataFiltroItem.vue?vue&type=template&id=7e7c8977&"
import script from "./DataFiltroItem.vue?vue&type=script&lang=js&"
export * from "./DataFiltroItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports